import { Box, Typography, styled, useTheme } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../redux/hooks';
import {
  ActivityTemplateType,
  clearSelectedTemplate,
  selectActivityTemplate,
} from '../../redux/activity/activitySlice';

const StyledTypography = styled(Typography)({
  paddingLeft: '16px',
  paddingTop: '0px',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    backgroundColor: 'currentColor',
    marginRight: '8px',
  },
});

function BlankActivity() {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const { t } = useTranslation();
  // const [isBlankTemplateSelected, setIsBlankTemplateSelected] = useState(false);

  useEffect(() => {
    dispatch(
      selectActivityTemplate({
        type: ActivityTemplateType.BLANK,
        activity: {
          id: '',
          name: '',
          type: 'blank',
          objective: '',
          coverImage: '',
          ActivityStep: [],
        },
      })
    );
    // setIsBlankTemplateSelected(true);
  }, []);
  const handleBlankActivityClick = () => {
    // handle event when click on blank activity
    // setIsBlankTemplateSelected(true);
    /*
    setting blank activity to template
    when user click on select and customize button,
    that selectedActivityTemplate is saved in draftActivity
    */
    dispatch(
      selectActivityTemplate({
        type: ActivityTemplateType.BLANK,
        activity: {
          id: '',
          name: '',
          type: 'blank',
          objective: '',
          coverImage: '',
          ActivityStep: [],
        },
      })
    );
  };

  useEffect(
    () => () => {
      dispatch(clearSelectedTemplate());
    },
    []
  );

  return (
    <Box
      width="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100%"
      bgcolor="rgba(255, 221, 200, 0.25)"
      borderLeft={theme.borderStyles.commonBorders}
    >
      <Box
        onClick={handleBlankActivityClick}
        maxWidth="325px"
        height="75%"
        width="33%"
        display="flex"
        flexDirection="column"
        borderRadius="10px"
        sx={{
          '&:hover': {
            scale: 1.5,
          },
          // boxShadow: !isBlankTemplateSelected
          //   ? '2px 2px 10px rgba(0, 0, 0, 0.1)'
          //   : '2px 2px 20px rgba(0, 0, 0, 0.2)',
          background:
            'linear-gradient(0deg, rgba(255, 221, 200, 0.80) 0%, rgba(255, 221, 200, 0.80) 100%), #FFF',
        }}
      >
        <Box display="flex" width="100%" alignItems="center" justifyContent="center" flex="2">
          <img src="/assets/icons/vector.svg" alt="dummy-img" />
        </Box>
        <Box
          bgcolor="#fff"
          height="40%"
          p="16px"
          display="flex"
          flexDirection="column"
          gap="10px"
          flex="1"
          borderRadius="0 0 10px 10px"
        >
          <Box display="flex" flexDirection="column">
            <Typography variant="bodyBold" color="primary">
              {t('common.title')}
            </Typography>
            <StyledTypography variant="meta" color="primary">
              {t('activity.createActivity.addYourSteps')}
            </StyledTypography>
          </Box>
          <Box display="flex" flexDirection="column">
            <Typography variant="meta" color="primary" fontWeight={500}>
              {t('activity.createActivity.advancedTrackingQuestions')}
            </Typography>
            <StyledTypography variant="meta" color="primary">
              {t('activity.createActivity.addAdvancedTrackingQuestions')}
            </StyledTypography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default BlankActivity;
